import { createTheme } from "@mui/material/styles";
import {
  Primary,
  // PrimaryLight,
  // PrimaryDark,
  PrimaryContrast,
  // PrimaryBG,
  // GreyDark,
  // Grey,
  Error,
  Success,
  Warning,
  Navy,
  Purple,
  Gold,
  Green,
  TextPrimary,
  TextMuted,
  Surface,
  Divider,
  SpacingUnit,
  MinTouchTarget,
  BaseFontSize,
  MobileBaseFontSize,
} from "./constants";

const theme = ({ base_colour, isMobile }) => {
  const responsiveBaseFontSize = isMobile ? MobileBaseFontSize : BaseFontSize;
  return createTheme({
    palette: {
      primary: {
        main: base_colour || Primary,
        contrastText: PrimaryContrast,
      },
      secondary: { main: Purple, contrastText: "#ffffff" },
      error: { main: Error },
      success: { main: Success },
      warning: { main: Warning, contrastText: Navy },
      navy: { main: Navy, contrastText: "#ffffff" },
      gold: { main: Gold, contrastText: Navy },
      green: { main: Green, contrastText: Navy },
      text: { primary: TextPrimary, secondary: TextMuted },
      divider: Divider,
      background: { default: "#ffffff", paper: "#ffffff", surface: Surface },
      white: {
        main: "#ffffff",
      },
      light: {
        main: "#f5f5f5",
      },
      black: {
        main: "#000000",
        contrastText: "#ffffff",
      },
      contrastThreshold: 3,
      tonalOffset: 0.2,
    },

    typography: {
      fontSize: responsiveBaseFontSize,
      fontFamily: ["Montserrat"].join(","),
      button: {
        textTransform: "none",
      },

      h1: {
        fontSize: responsiveBaseFontSize * 3,
        fontWeight: 600,
      },
      h2: {
        fontSize: responsiveBaseFontSize * 2.5,
        fontWeight: 600,
      },
      h3: {
        fontSize: responsiveBaseFontSize * 2,
        fontWeight: 600,
      },
      h4: {
        fontSize: responsiveBaseFontSize * 1.5,
        fontWeight: 600,
      },
      h5: {
        fontSize: responsiveBaseFontSize * 1.25,
        fontWeight: 600,
      },
      h6: {
        fontSize: responsiveBaseFontSize,
        fontWeight: 600,
      },
      title: {
        fontSize: responsiveBaseFontSize * 2.5,
        lineHeight: 1.5,
      },
      body1: {
        fontSize: responsiveBaseFontSize,
      },
      body2: {
        fontSize: responsiveBaseFontSize * 0.875,
      },
      finePrint: {
        fontSize: responsiveBaseFontSize * 0.7,
      },
      subtitle1: {
        fontSize: responsiveBaseFontSize * 2,
        lineHeight: 1.5,
      },
      subtitle2: {
        fontSize: responsiveBaseFontSize * 1.5,
        lineHeight: 1.5,
      },
    },
    shape: {
      borderRadius: 12,
    },
    spacing: SpacingUnit,
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: { color: TextPrimary, WebkitFontSmoothing: "antialiased" },
          // One visible keyboard focus ring for every interactive element.
          "a:focus-visible, button:focus-visible, [role='button']:focus-visible, input:focus-visible, [tabindex]:focus-visible":
            { outline: `3px solid ${Navy}`, outlineOffset: 2 },
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "outlined",
        },
      },
      MuiButton: {
        defaultProps: {
          variant: "contained",
          disableRipple: true,
          disableFocusRipple: true,
        },
        styleOverrides: {
          root: { minHeight: MinTouchTarget, borderRadius: 12, fontWeight: 600 },
          sizeLarge: {
            fontSize: "1rem",
            minHeight: 52,
          },
          sizeMedium: {
            fontSize: "0.875rem",
          },
        },
      },
      MuiIconButton: {
        styleOverrides: { root: { minWidth: MinTouchTarget, minHeight: MinTouchTarget } },
      },
      MuiChip: {
        styleOverrides: { root: { fontWeight: 600 } },
      },
      MuiCheckbox: {
        defaultProps: {
          disableRipple: true,
          color: "primary",
        },
      },
      MuiRadio: {
        defaultProps: { disableRipple: true, color: "primary" },
      },
      MuiSwitch: {
        defaultProps: { color: "primary", disableRipple: true },
      },
      MuiTab: {
        defaultProps: { disableRipple: true },
      },
      MuiToggleButtonGroup: {
        styleOverrides: {
          root: {
            border: "none",
            padding: "8px",
            backgroundColor: "#F5F5F5",
          },
        },
      },
      MuiToggleButton: {
        styleOverrides: {
          root: {
            border: "none",
            borderRadius: "8px !important",
            "&.MuiToggleButton-primary": {
              color: base_colour || Primary,
              "&.Mui-selected": {
                backgroundColor: base_colour || Primary,
                color: "#ffffff",
              },
            },
          },
        },
      },
    },
  });
};

export default theme;
